const state = {
  checkNodeData: {},
  areaAllList: [],
  checkAreaListID: [],
  paginObj: {
    pageSize: 20,
    pageIndex: 1,
  },
  areaId: '',
};

const mutations = {
  SET_CHECKNODEDATA: (state, data) => {
    state.checkNodeData = data;
  },
  SET_AREAALLLIST: (state, data) => {
    state.areaAllList = data;
  },
  SET_CHECKAREALISTID: (state, data) => {
    state.checkAreaListID = data;
  },
  SET_PAGINOBJ: (state, data) => {
    state.paginObj = data;
  },
  SET_AREAID: (state, data) => {
    state.areaId = data;
  },
  // 删除tree节点
  DELETE_CHECKNODEDATA: (state, list) => {
    let nodeData = state.checkNodeData;
    // 大于0说明是checkNodeData为父节点的数据，否则是点击当前节点，那就找到当前节点的父节点来删除
    let childNodes =
      nodeData.childNodes.length > 0
        ? nodeData.childNodes
        : nodeData.parent.childNodes;
    list.forEach((key) => {
      childNodes.forEach((item, index, arr) => {
        if (item.data.areaId === key) {
          arr.splice(index, 1);
        }
      });
    });
    state.checkNodeData = nodeData;
  },
};

const actions = {
  setCheckNodeData({ commit }, data) {
    commit('SET_CHECKNODEDATA', data);
  },
  setAreaAllList({ commit }, data) {
    commit('SET_AREAALLLIST', data);
  },
  setCheckAreaListID({ commit }, data) {
    commit('SET_CHECKAREALISTID', data);
  },
  setPaginObj({ commit }, data) {
    commit('SET_PAGINOBJ', data);
  },
  deleteCheckNodeData({ commit }, list) {
    commit('DELETE_CHECKNODEDATA', list);
  },
  setAreaIdData({ commit }, data) {
    commit('SET_AREAID', data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
